import T from 'mrf/utils/T';
import Button from './Button';
import PropTypes from 'prop-types';
import { WarningModalDeleteIcon } from 'mrf/styles/basic/icons';

export default function ConfirmationModal({ 
    isOpen, 
    title = "Confirm Save",
    message = "Do you want to save this item?",
    confirmLabel = 'Confirm', 
    cancelLabel = 'Cancel', 
    onCancel,
    onConfirm,
    icon: Icon = WarningModalDeleteIcon, 
    additionalInfoModal
}) {

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
                <div className="flex items-center">
                    {Icon && <Icon size={24} className="h-6 w-6 text-yellow-500 mr-3" />} 
                    <h3 className="text-lg font-semibold text-gray-800">
                        <T>{title}</T>
                    </h3>
                </div>
                <p className="mt-4 text-gray-600">
                    <T>{message}</T>
                </p>

                {additionalInfoModal && (
                    <p className="mt-6 font-semibold italic text-justify">
                        <T>{additionalInfoModal}</T>
                    </p>
                )}

                <div className="mt-6 flex justify-end gap-4">
                    <Button 
                        color="secondary" 
                        type="button" 
                        onClick={onCancel}
                    >
                        <T>{cancelLabel}</T>
                    </Button>
                    <Button 
                        color="primary" 
                        type="button" 
                        onClick={onConfirm}
                    >
                        <T>{confirmLabel}</T>
                    </Button>
                </div>
            </div>
        </div>
    );
}

ConfirmationModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,            // controls whether the modal is open
    onCancel: PropTypes.func.isRequired,          // function called when canceling
    onConfirm: PropTypes.func.isRequired,         // function called when confirming
    title: PropTypes.string.isRequired,           // title of the modal (default: 'Confirm Save')
    message: PropTypes.string.isRequired,         // main message of the modal (default: 'Do you want to save this item?')
    confirmLabel: PropTypes.string,               // text for the confirmation button (default: 'Confirm')
    cancelLabel: PropTypes.string,                // text for the cancel button (default: 'Cancel')
    icon: PropTypes.elementType,                  // optional icon (default: WarningModalDeleteIcon)
    additionalInfoModal: PropTypes.string,        // optional additional text
};
